var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPcloudLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 70
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "pcloud-logo_svg__a",
    x: 0,
    y: 0,
    width: 70,
    height: 70,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.102
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 133"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#pcloud-logo_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 47",
    transform: "translate(3 2)",
    fill: "#fff",
    stroke: "rgba(0,0,0,0.05)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 14,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 63,
    height: 63,
    rx: 13.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "Subtraction 4",
    d: "M54.103 51.528H20.386a13.074 13.074 0 01-5.157-1.052 13.369 13.369 0 01-7.055-7.12 13.4 13.4 0 01-1.045-5.206 13.948 13.948 0 01.847-4.825 13.141 13.141 0 012.353-4.026 12.7 12.7 0 018.1-4.361 16.326 16.326 0 00-1.31 6.325h.118a18.086 18.086 0 015.857-11.285 17.766 17.766 0 0123.821 0 18.089 18.089 0 015.854 11.282h.113a17.276 17.276 0 00-1.419-6.4 4.756 4.756 0 01.758-.04 7.409 7.409 0 015.3 2.209 7.584 7.584 0 01-1.878 12.07 7.573 7.573 0 003.992-3.524 8.63 8.63 0 012.381 3.014 9.178 9.178 0 01-1.707 10.223 8.873 8.873 0 01-6.206 2.7v.013zm-19.11-32.6a14.12 14.12 0 00-5.592 1.143 14.3 14.3 0 00-4.572 3.118 14.635 14.635 0 000 20.557 14.3 14.3 0 004.568 3.115 14.262 14.262 0 0011.184 0 14.3 14.3 0 004.567-3.115 14.633 14.633 0 000-20.557 14.292 14.292 0 00-4.567-3.115 14.123 14.123 0 00-5.588-1.142zm0 27.311a12.775 12.775 0 1112.626-12.771 12.715 12.715 0 01-12.626 12.774zm-3.918-20.7a2.18 2.18 0 00-2.177 2.177v11.5a2.177 2.177 0 104.354 0v-2.224h4.049a5.729 5.729 0 000-11.451h-.131zm6.075 7.488h-3.9v-3.528h3.9a1.762 1.762 0 110 3.523z",
    fill: "#17bed0"
  }))));
}
export default SvgPcloudLogo;